
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PenSquare, Image, Play, Share2, ShoppingBag, Video, ArrowLeft } from "lucide-react";
import { Loader2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface NavigationPaneProps {
  onCreateDrill: () => void;
  onGenerateImage: () => void;
  onSimulateDrill: () => void;
  isGeneratingImage: boolean;
  onNavigateToMarketplace: () => void;
  selectedForConversion: boolean;
  onToggleVideoSection: () => void;
  showVideoSection: boolean;
}

const NavigationPane = ({
  onCreateDrill,
  onGenerateImage,
  onSimulateDrill,
  isGeneratingImage,
  onNavigateToMarketplace,
  selectedForConversion,
  onToggleVideoSection,
  showVideoSection,
}: NavigationPaneProps) => {
  const { toast } = useToast();

  const handleGenerateImage = () => {
    if (!selectedForConversion) {
      toast({
        variant: "destructive",
        title: "Selection Required",
        description: "Please select the text for conversion using the checkbox in the editor.",
      });
      return;
    }
    onGenerateImage();
  };

  return (
    <Card className="lg:col-span-3 bg-white/80 backdrop-blur-sm border border-blue-100 shadow-lg">
      <CardHeader>
        <CardTitle>Navigation</CardTitle>
        <CardDescription>Manage your drills</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-2">
          {showVideoSection ? (
            <Button variant="ghost" className="justify-start" onClick={onToggleVideoSection}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Drills
            </Button>
          ) : (
            <>
              <Button variant="ghost" className="justify-start" onClick={onCreateDrill}>
                <PenSquare className="mr-2 h-4 w-4" />
                Create Drill
              </Button>
              <Button 
                variant="ghost" 
                className="justify-start" 
                onClick={handleGenerateImage}
                disabled={isGeneratingImage || !selectedForConversion}
              >
                {isGeneratingImage ? (
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                ) : (
                  <Image className="mr-2 h-4 w-4" />
                )}
                {isGeneratingImage ? "Generating..." : "Convert to Image"}
              </Button>
              <Button 
                variant="ghost" 
                className="justify-start"
                onClick={onSimulateDrill}
              >
                <Play className="mr-2 h-4 w-4" />
                Simulate Drill
              </Button>
              <Button variant="ghost" className="justify-start">
                <Share2 className="mr-2 h-4 w-4" />
                Share Drill
              </Button>
              <Button 
                variant="ghost" 
                className="justify-start"
                onClick={onToggleVideoSection}
              >
                <Video className="mr-2 h-4 w-4" />
                Video Analysis
              </Button>
              <Button 
                variant="ghost" 
                className="justify-start text-green-600 hover:text-green-700 hover:bg-green-50"
                onClick={onNavigateToMarketplace}
              >
                <ShoppingBag className="mr-2 h-4 w-4" />
                Go to Marketplace
              </Button>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default NavigationPane;
